module.exports = __webpack_public_path__ + "static/media/I'm Not Ready - Instrumental Version.6c21d982.jpg";